import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth';

@Injectable()
export class PasswordChangeInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (
          error.status === 403 &&
          error.error?.code === 'PASSWORD_CHANGE_REQUIRED'
        ) {
          this.authService.setDebeCambiarPassword(true);

          if (!this.router.url.startsWith('/cambiar-password')) {
            this.router.navigate(['/cambiar-password']);
          }
        }

        return throwError(() => error);
      }),
    );
  }
}
